import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";

// Static suggestions shown on the left column.
// Replace this with a real suggestions API later if you have one —
// for now it's the same idea as the reference screenshot (quick shortcuts).
const DEFAULT_SUGGESTIONS = [
  "Ring",
  "Earrings",
  "Necklace",
  "Bracelet",
  "Studds",
  "Pendant",
  "Gift Sets",
];

function SearchCanvas({ isOpen, searchText, setSearchText }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  // useEffect(() => {
  //   if (!searchText) {
  //     setProducts([]);
  //     return;
  //   }

  //   const delay = setTimeout(() => {
  //     fetchProducts(searchText);
  //   }, 400);

  //   return () => clearTimeout(delay);
  // }, [searchText]);

  useEffect(() => {
  const delay = setTimeout(() => {
    fetchProducts(searchText);
  }, 400);

  return () => clearTimeout(delay);
}, [searchText]);

  const fetchProducts = async (searchText) => {
    setLoading(true);

    try {
      // const res = await productAPI.listing({
      //   page: 1,
      //   limit: 8,
      //   keyword: searchText,
      // });

      const res = await productAPI.listing({
  page: 1,
  limit: 8,
  ...(searchText ? { keyword: searchText } : {}),
});

      if (res.code === 200) {
        setProducts(res.data.products || []);
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (term) => {
    setSearchText(term);
  };

  return (
    <div className="salty-search-box">
      {/* SEARCH INPUT */}
      <div className="salty-search-input-wrap">
        <Search size={18} strokeWidth={1.8} className="salty-search-icon" />
        <input
          type="text"
          autoFocus
          className="salty-search-input"
          placeholder="Search For Products"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      {/* RESULTS PANEL — absolutely positioned, floats over the page */}

      <div className="salty-search-results">
        <div className="salty-search-suggestions">
          <p className="salty-suggestions-title">Search Suggestions</p>
          <ul className="salty-suggestions-list">
            {DEFAULT_SUGGESTIONS.map((term) => (
              <li key={term}>
                <button
                  type="button"
                  className={`salty-suggestion-item${
                    term.toLowerCase() === searchText.toLowerCase()
                      ? " active"
                      : ""
                  }`}
                  onClick={() => handleSuggestionClick(term)}
                >
                  {term}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="salty-search-products">
          {loading && <p className="salty-search-status">Searching...</p>}

         {searchText && !loading && products.length === 0 && (
  <p className="salty-search-status">
    No products found for "{searchText}"
  </p>
)}

          {!loading && products.length > 0 && (
            <>
              <div className="salty-search-grid">
                {products.map((product) => {
                  const image = product?.thumbnail || product?.images?.[0];
                  const price = product?.variants?.[0]?.price || product?.price;
                  const mrp = product?.variants?.[0]?.mrp || product?.mrp;

                  return (
                    <Link
                      to={`/shop/${product.slug}`}
                      className="salty-search-card"
                      key={product._id}
                      onClick={() => setSearchText("")}
                    >
                      <div className="salty-search-card-img">
                        {mrp && mrp > price && (
                          <span className="salty-sale-badge">Sale</span>
                        )}
                        <img src={image} alt={product.title} />
                      </div>
                      <p className="salty-search-card-title">{product.title}</p>
                      <p className="salty-search-card-price">
                        {mrp && mrp > price && (
                          <span className="salty-price-mrp">₹{mrp}</span>
                        )}
                        <span className="salty-price-final">₹{price}</span>
                      </p>
                    </Link>
                  );
                })}
              </div>

              {/* <Link
                to={`/shop?keyword=${searchText}`}
                className="salty-search-viewall"
                onClick={() => setSearchText("")}
              >
                View all results for "{searchText}"
              </Link> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchCanvas;
